<template>
  <div>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="'紀錄列表'"></page-title>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>客戶名稱</label>
              <md-input v-model="patient_name"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-field>
              <label>客戶編號</label>
              <md-input v-model="patient_id_alt"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-field>
              <label>治療師</label>
              <md-select v-model="doctor_id">
                <md-option :value="''">全部</md-option>
                <md-option v-for="(doctor, index) in doctors" :doctors="doctors" :key="doctor.id" :value="doctor.id">{{doctor.name}}</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item">
            <md-field>
              <label>完成狀態</label>
              <md-select v-model="is_completed">
                <md-option :value="''">全部</md-option>
                <md-option :value="'true'">完成</md-option>
                <md-option :value="'false'">未完成</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised md-danger" @click="clearAll">清除搜尋結果</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="float-right md-raised md-primary" @click="getRecords()">搜尋</md-button>
          <a v-if="notCompletedCount > 0" class="not-completed float-right md-raised md-primary" @click="searchNotCompleted()">檢視自己的 {{notCompletedCount}} 個未完成紀錄</a>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-table>
            <md-table-row>
              <md-table-head>掛號時間</md-table-head>
              <md-table-head>客戶名稱</md-table-head>
              <md-table-head>客戶編號</md-table-head>
              <md-table-head>服務費用</md-table-head>
              <md-table-head>附件</md-table-head>
              <md-table-head v-if="hasScope(['RECORD_EXPORT', 'RECORD_EXPORT_PROOF', 'RECORD_EXPORT_RECEIPT'])">其他</md-table-head>
            </md-table-row>
            <md-table-row v-for="(record, index) in records" :records="record" :key="record.id">
              <md-table-cell>
                <router-link :to="`/record/${record.id}`">
                  {{dateConvert(record.registered_at)}}
                </router-link>
              </md-table-cell>
              <md-table-cell>
                {{record.patient.name}}
              </md-table-cell>
              <md-table-cell>
                {{record.patient.id_alt}}
              </md-table-cell>
              <md-table-cell>
                {{record.usage.length > 0 ? Math.round(record.usage.map(i => i.quantity * i.item.price).reduce((a, b) => a + b)) : 0}}
              </md-table-cell>
              <md-table-cell>
                <a :href=file.url :title=file.filename v-for="file in record.file" target="_blank">
                  <md-icon>attach_file</md-icon>
                </a>
              </md-table-cell>
              <md-table-cell>
                <md-menu>
                  <a md-menu-trigger>其他動作</a>
                  <md-menu-content>
                    <md-menu-item @click="getReceipt(record.id)" v-if="hasScope('RECORD_EXPORT_RECEIPT')">匯出收據</md-menu-item>
                    <md-menu-item @click="getProof(record.id)" v-if="hasScope('RECORD_EXPORT_PROOF')">匯出就醫證明</md-menu-item>
                    <md-menu-item @click="getExport(record.id)" v-if="hasScope('RECORD_EXPORT')">匯出服務紀錄</md-menu-item>
                  </md-menu-content>
                </md-menu>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>
      <div class="md-layout md-gutter md-alignment-center-center paginate-container">
        <div class="md-layout-item md-size-100">
          <paginate
            :initial-page="page - 1"
            :page-count="Math.ceil(pageCount / 20)"
            :click-handler="getRecords"
            :prev-text="'前頁'"
            :next-text="'下頁'"
            :container-class="'pagination'"
            :no-li-surround="true"
          >
          </paginate>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import axios from 'axios'
import moment from 'moment'
import urls from '@/urls'
import Paginate from 'vuejs-paginate'
import { hasScope } from '@/services/auth'
import store from '@/store'

export default {
  data () {
    return {
      records: [],
      doctors: [],
      pageCount: 0,
      notCompletedCount: 0
    }
  },
  store,
  components: {
    PageTitle, Paginate
  },
  created () {
    this.getDoctor()
    this.clearAll()
    this.getRecords(this.page)
  },
  methods: {
    hasScope,
    clearAll: async function () {
      if (this.$store.state.RecordList.dontClear) {
        this.$store.commit('RecordList/dontClear', false)
        return
      }
      this.records = []
      this.patient_name = ''
      this.patient_id_alt = ''
      this.is_completed = ''
      this.doctor_id = ''
      this.patient_id = ''
      this.$store.commit('RecordList/dontClear', false)
    },
    getRecords: async function (page = 1) {
      const payload = {
        patient_name: this.patient_name,
        patient_id_alt: this.patient_id_alt,
        is_completed: this.is_completed,
        doctor_id: this.doctor_id,
        patient_id: this.patient_id,
        page
      }
      let req = await axios.get(urls({route: 'record'}), {params: payload})
      this.records = req.data.data
      this.pageCount = req.data.count
      this.getNotCompleted()
      this.$store.commit('RecordList/updatePage', page)
    },
    searchNotCompleted: async function () {
      this.is_completed = false
      this.doctor_id = this.$store.state.auth.user.id
      this.getRecords()
    },
    dateConvert: function (date) {
      let from = moment(date[0]).format('YYYY-MM-DD HH')
      let until = moment(date[1]).format('YYYY-MM-DD HH')
      return `${from}:00 - ${until}:00`
    },
    getProof: function (id) {
      axios({
        method: 'get',
        url: urls({route: `record/${id}/proof`}),
        responseType: 'blob'
      }).then(function (resp) {
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(resp.data)
        link.download = '匯出就醫證明.docx'
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    getNotCompleted: async function (id) {
      const payload = {
        patient_name: this.patient_name,
        patient_id_alt: this.patient_id_alt,
        doctor_id: this.$store.state.auth.user.id,
        is_completed: false
      }
      let req = await axios.get(urls({route: 'record'}), {params: payload})
      this.notCompletedCount = req.data.count
    },
    getDoctor: async function () {
      let req = await axios.get(urls({route: 'user'}), {
        params: {
          role_name: '治療師',
          limit: 100
        }
      })
      this.doctors = req.data.data
    },
    getReceipt: function (id) {
      axios({
        method: 'get',
        url: urls({route: `record/${id}/receipt`}),
        responseType: 'blob'
      }).then(function (resp) {
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(resp.data)
        link.download = '匯出收據.docx'
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    getExport: function (id) {
      axios({
        method: 'get',
        url: urls({route: `record/${id}/record`}),
        responseType: 'blob'
      }).then(function (resp) {
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(resp.data)
        link.download = '匯出服務紀錄.docx'
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    }
  },
  computed: {
    patient_id_alt: {
      get () { return this.$store.state.RecordList.content.patient_id_alt },
      set (value) { this.$store.commit('RecordList/updatePatientIdAlt', value) }
    },
    doctor_id: {
      get () { return this.$store.state.RecordList.content.doctor_id },
      set (value) { this.$store.commit('RecordList/updateDoctorId', value) }
    },
    is_completed: {
      get () { return this.$store.state.RecordList.content.is_completed },
      set (value) { this.$store.commit('RecordList/updateIsCompleted', value) }
    },
    patient_name: {
      get () { return this.$store.state.RecordList.content.patient_name },
      set (value) { this.$store.commit('RecordList/updatePatientName', value) }
    },
    page: {
      get () { return this.$store.state.RecordList.content.page },
      set (value) { this.$store.commit('RecordList/updatePage', value) }
    },
    patient_id: {
      get () { return this.$store.state.RecordList.content.patient_id },
      set (value) { this.$store.commit('RecordList/updatePatientId', value) }
    }
  }
}
</script>

<style>
.not-completed {
  line-height: 40px;
  margin: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Record/RecordList.vue